<app-modal-confirmation-std4-skin [header]="'CONFIGURATION.NOTIFICATION' | translate"
  [showDismissButton]="false"
  [showSubmitButton]="false"
  (dismiss)="denyLogin()">
  <ng-template>
    <countdown class="d-none"
      [config]="config"
      (event)="handleEvent($event)" />
    <div class="d-flex flex-column align-items-center justify-content-center w-100">
      <div class="mb-3 mb-lg-4">
      <svg class="text-std-color-primary"
        height="56"
        width="56"
        fill="currentColor">
        <use height="56"
          width="56"
          href="assets/images/icons/marks/question-fill.svg#question-fill"></use>
      </svg>
      </div>
      <label class="fs-u1 fs-lg-u2 fw-md-medium text-center mb-1">
        {{ "CONFIGURATION.LOG-IN-FROM-ANOTHER-DEVICE" | translate }}
      </label>
      <label class="fs-l2 fw-normal text-center text-gray-neutrals mb-0">
        {{ "CONFIGURATION.WARNING-CHECK-LOGIN" | translate }}
      </label>
    </div>
    <div class="d-flex mt-4">
      <button class="me-auto btn btn-std btn-cus-green fs-base-l4 mx-1 py-base-l8 "
        type="button"
        (click)="resetPassword()">
        {{ 'COMMON.RESET-PASSWORD.Reset password' | translate }}
      </button>
      <button class="btn btn-std btn-std-outline fs-base-l4 mx-1 fw-semibold justify-content-center"
        type="button"
        (click)="denyLogin()">
        {{ 'COMMON.Cancel' | translate }}
      </button>
      <button class="btn btn-std btn-std-prim fs-base-l4 mx-1 py-base-l8 "
        type="button"
        (click)="allowLogin()">
        {{ 'COMMON.Confirm' | translate }}
      </button>
    </div>
  </ng-template>
</app-modal-confirmation-std4-skin>